export default __webpack_public_path__ + "static/equilibre_icon_dashboard-e1410bed71f6f633b47bc98dbac2f6d5.png";